
import {get,post} from "@/axios";


export function chart(data) {
    return post('/api/trafficStatistics/chart',data);
}
